let userData = {
  permissions: [],
};

export const addUserData = (data) => {
  userData = { ...data };
};

export const checkPermission = (val) => userData?.permissions?.includes(val);
